import { gql } from '@apollo/client';

export const GET_CONTENT = gql`
  query contentById($id: String!) {
    content(id: $id) {
        _id
        title
        shortDescription
        longDescription
        summary
        estimatedTime
        image
        fileContent
        transcript
        transcriptVisible
        type
        designSystemColor
        activityType
        humanReadableId
    }
  }
`;